export default {"src":"/_next/static/media/kmd.1673b3b2.svg","height":30,"width":96,"blurWidth":0,"blurHeight":0};